import React, { useEffect, useRef, useState } from "react";
import "./App.css";
import About from "./Component/About/About";
import Contact from "./Component/Contact/Contact";
import Education from "./Component/Education/Education";
import Header from "./Component/Header/Header";
// import MyParticles from "./Component/MyParticles/MyParticles";
import Navbar from "./Component/Navbar/Navbar";
import CertificationsData from "./Component/Portfolio/Data/CertificationsData";
import ProjectData from "./Component/Portfolio/Data/ProjectData";
import Portfolio from "./Component/Portfolio/Portfolio";
import ProfessionalSkills from "./Component/ProfessionalSkills/ProfessionalSkills";
import References from "./Component/References/References";
import { getAllCategoriesLink } from "./Utils";

const uniqueAllCategoriesLink = getAllCategoriesLink(CertificationsData);
const uniqueAllCategoriesForProjectLink = getAllCategoriesLink(ProjectData);

function App() {
  const [height, setHeight] = useState(window.innerHeight);
  const [aboutHeight, setAboutHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      if (window.innerWidth > 582) {
        setAboutHeight(window.innerHeight);
      } else {
        setAboutHeight("max-content");
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const skillsRef = useRef(null);
  const experienceRef = useRef(null);
  const aboutRef = useRef(null);
  const portfolioRef = useRef(null);
  const referencesRef = useRef(null);
  const contactRef = useRef(null);
  const certificationsRef = useRef(null);
  return (
    <>
      <div>{/* <MyParticles /> */}</div>
      <div className="fixed-top">
        <Navbar
          skillsRef={skillsRef}
          experienceRef={experienceRef}
          aboutRef={aboutRef}
          portfolioRef={portfolioRef}
          referencesRef={referencesRef}
          contactRef={contactRef}
        />
      </div>
      <Header />
      <div
        className="container-fluid bg-color-div"
        style={{ backgroundColor: "#313743" }}
      >
        <div
          className="container container-my"
          style={{ height: aboutHeight, zIndex: "50" }}
          ref={aboutRef}
        >
          <About />
        </div>
      </div>
      <div
        className="container-fluid bg-color-div"
        style={{ backgroundColor: "#1F232E" }}
      >
        <div
          className="container container-my"
          style={{ height: height }}
          ref={skillsRef}
        >
          <ProfessionalSkills />
        </div>
      </div>
      <div
        className="container-fluid bg-color-div"
        style={{ backgroundColor: "#313743" }}
      >
        <div className="container container-my" ref={experienceRef}>
          <Education />
        </div>
      </div>
      <div
        className="container-fluid bg-color-div"
        style={{ backgroundColor: "#1F232E" }}
      >
        <div className="container container-my" ref={portfolioRef}>
          <Portfolio
            headingTitle="Projects"
            dataList={ProjectData}
            allCategories={uniqueAllCategoriesForProjectLink}
            description
          />
        </div>
      </div>
      <div
        className="container-fluid bg-color-div"
        style={{ backgroundColor: "#313743" }}
      >
        <div className="container container-my" ref={certificationsRef}>
          <Portfolio
            headingTitle="Certifications"
            dataList={CertificationsData}
            allCategories={uniqueAllCategoriesLink}
          />
        </div>
      </div>
      {/* <div
        className="container-fluid bg-color-div"
        style={{ backgroundColor: "#1F232E" }}
      >
        <div
          className="container container-my"
          style={{ height: height }}
          ref={referencesRef}
        >
          <References />
        </div>
      </div> */}
      <div
        className="container-fluid"
        style={{ height: height, padding: 0 }}
        ref={contactRef}
      >
        <Contact />
      </div>
    </>
  );
}

export default App;
